import React from 'react';
import { TemplateId } from './share/TemplateRegistry';
import { ReviewTemplateProps } from './share/types';

export const REVIEWS_PER_PAGE = 6;

export interface CurrentFilters {
    status: string[];
    network: string[];
}

interface ReviewReplyProps {
    comment: string;
    updateTime: string;
}

export interface Review {
    id: string;
    network: string;
    reviewer: string;
    text: string;
    created_at: string;
    updated_at: string;
    rating: string;
    review_reply: string | ReviewReplyProps;
    status: string;
    hasBeenRead: boolean;
    single_survey_link: string;
    external_url?: string;
    comments?: any[];
}

export interface BasePlatformRating {
    platform: 'google_my_business' | 'facebook' | 'opinion_system';
    totalReviews: number;
}

export interface StarRatingPlatform extends BasePlatformRating {
    platform: 'google_my_business' | 'opinion_system';
    rating: number;
}

export interface FacebookRatingPlatform extends BasePlatformRating {
    platform: 'facebook';
    rating: number;
}

export type PlatformRating = StarRatingPlatform | FacebookRatingPlatform;

export interface ReviewsListProps {
    reviews: Review[];
    openModal: (review: Review) => void;
    isLoading: boolean;
    onReviewsUpdate: (reviews: Review[]) => void;
    currentPage: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

export interface ReviewsHeaderProps {
    platformRatings: PlatformRating[];
    isLoading: boolean;
    loadingState?: {
        gmb: boolean;
        facebook: boolean;
        opinionSystem: boolean;
    };
    onRefresh?: () => void;
}

export interface ReviewBladeInfoProps {
    isLoading: boolean;
}

export interface ModalResponseProps {
    isOpen: boolean;
    onClose: () => void;
    selectedReview: Review | null;
    setContent: React.Dispatch<React.SetStateAction<string>>;
    content: string;
    setRefreshReviews: React.Dispatch<React.SetStateAction<number>>;
}

export interface ModalNotAllowedProps {
    isLoading: boolean;
    setShowIfNotAllowed: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface FilterOption {
    value: string;
    label: string;
    icon?: string;
}

export interface FilterGroup {
    id: 'status' | 'network';
    label: string;
    options: FilterOption[];
}

export interface CurrentFilters {
    status: string[];
    network: string[];
}

export interface FilterSorterProps {
    onFilterChange: (filterType: 'status' | 'network', value: string) => void;
    onSortChange: (sortValue: string) => void;
    showFilter: boolean;
    showSorter: boolean;
    toggleShowFilter: () => void;
    toggleShowSorter: () => void;
    currentFilters: CurrentFilters;
    currentSort: string;
    platformRatings: PlatformRating[];
}

export interface ReviewCardProps {
    review: Review;
    isNew: boolean;
    getNetworkLogo: (network: string) => string;
    onShare: (review: Review) => void;
    onReply: (review: Review) => void;
    onOpinionSystemRedirect: (url: string) => void;
}

export interface ReviewCardActionsProps {
    review: Review;
    hasReply: boolean;
    onShare: (review: Review) => void;
    onReply: (review: Review) => void;
    onOpinionSystemRedirect: (url: string) => void;
}

export interface ColorPickerProps {
    selectedColor: string;
    onColorChange: (color: string) => void;
}

export interface TemplateSelectorProps {
    selectedTemplate: TemplateId;
    onTemplateChange: (templateId: TemplateId) => void;
    templateProps: ReviewTemplateProps;
}

export interface TextEditorProps {
    reviewerName: string;
    reviewText: string;
    onReviewerNameChange: (name: string) => void;
    onReviewTextChange: (text: string) => void;
}
